import React from 'react'
import { ReferenceInput, AutocompleteInput } from 'react-admin'

const CitiesSelect = (props) => (
  <ReferenceInput
    fullWidth
    source={props.isEdit ? 'city.id' : 'cities.id'}
    label='Город'
    reference='cities'
    filterToQuery={(name) => ({ name })}
    {...props}
  >
    <AutocompleteInput optionValue='id' optionText='name' />
  </ReferenceInput>
)

export default CitiesSelect
